import React, { useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Container } from "reactstrap";
// import { Link } from "react-router-dom";

import * as INITIAL_DATA from "./INITIAL_DATA";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import "./style.css";
import api from "../../config/api";
import GradientButton from "../../component/GradientButton/GradientButton";
import TextInputOutline from "../../component/TextInputOutline/TextInputOutline";
import historyAction from "../../redux/history/action";
import authAction from "../../redux/auth/action";
import { isNetworkRequestFailedError } from "../../config/helpers";

const UserActivation = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOTP] = useState("");
  const [errors, setErrors] = useState({});
  const [resendTimer, setResendTimer] = useState(60);
  const [resendTimerBoolean, setResendTimerBoolean] = useState(true);
  const resendInterval = useRef(null);

  const data = props.activationOptionModal?.data || INITIAL_DATA.USER;

  console.log("data =>", data);

  useEffect(() => {
    if (resendTimerBoolean) {
      resendInterval.current = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      if (resendInterval.current) {
        clearInterval(resendInterval.current);
      }
    };
  }, [resendTimerBoolean]);

  useEffect(() => {
    if (resendInterval.current && resendTimer <= 0) {
      clearInterval(resendInterval.current);
      setResendTimerBoolean(false);
    }
  }, [resendTimer]);

  useEffect(() => {
    const { history, setHistory } = props;

    // if (!localHistory) {
    //   // window.location.replace("/register");
    // }

    if (!data || !Object.keys(data).length) {
      history.push("/login");
    }

    setHistory(history);
  }, []);

  const changeHandler = (e) => {
    const name = e.target.name;

    if (name === "OTP") {
      setOTP(e.target.value);
    }
  };

  const submit = async (e) => {
    const { localHistory, setAlertMessage } = props;
    e.preventDefault();

    try {
      if (validate()) return;

      setIsLoading(true);

      const payload = {
        username: data.UserName,
        activationToken: otp,
      };
      console.log("payload =>", payload);

      const response = await api.regActivation(payload);

      setAlertMessage({
        type: "success",
        message:
          response.data.message || response.data.SuccessMessage || "Successful",
      });
      localHistory.push("/login");
    } catch (error) {
      setAlertMessage({
        type: "error",
        message: error.message,
        onTryAgain: isNetworkRequestFailedError(error) ? () => submit(e) : null,
      });
    }

    setIsLoading(false);
  };

  const validate = () => {
    const errors = {};

    if (!otp) {
      errors.OTPError = "Please fill all mandatory fields";
    }

    setErrors(errors);

    console.log("errors =>", errors);

    return Object.keys(errors).length;
  };

  const resendOTP = async () => {
    try {
      setIsLoading(true);
      console.log("data =>", data);

      const payload = {
        username: data.UserName,
      };
      console.log("payload =>", payload);
      const response = await api.getActivationStatus(payload);

      console.log("response =>", response);

      if (response?.data.SuccessMessage) {
        props.setAlertMessage({
          type: "success",
          message: response?.data.SuccessMessage,
        });
        props.localHistory.push("/login");
        setIsLoading(false);
        return;
      }

      props.setAlertMessage({
        type: "success",
        message: "Sent successfully",
      });
      setResendTimerBoolean(true);
      setResendTimer(60);
    } catch (e) {
      props.setAlertMessage({
        type: "error",
        message: e.message,
        onTryAgain: isNetworkRequestFailedError(e) ? resendOTP : null,
      });
    }

    setIsLoading(false);
  };

  return (
    <div className="login-main-container">
      <Container>
        <div className="login-container">
          <img
            alt="app-icon"
            src={require("../../assets/icons/app-icon.png")}
          />
          <p className="login-container-app-name">Premium Pension Limited</p>
          <p className="mt-4 text-center">
            Enter the token sent to your phone number and email address
          </p>
          <form
            className="mb-5 mt-4 login-input-container align-items-start"
            onSubmit={submit}
          >
            <div className="my-2 w-100">
              <TextInputOutline
                onChange={changeHandler}
                value={otp}
                name="OTP"
                label="Enter 6 digit code"
                errorMessage={errors.OTPError}
              />
              {resendTimer > 0 ? (
                <p className="mt-3 text-right">
                  You can request again in <b>{resendTimer}</b> seconds
                </p>
              ) : (
                <p onClick={resendOTP} className="mt-3 text-right pointer">
                  Resend OTP
                </p>
              )}
            </div>
            <GradientButton
              type="submit"
              containerClasses="mt-4 mx-auto"
              label="Activate"
            />
            <div className="text-center w-100 mt-2"></div>
          </form>
        </div>
      </Container>
      {isLoading && <CustomLoader text="Please wait" />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
  localHistory: state.history.localHistory,
  activationOptionModal: state.activationOptionModal,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  setAlertMessage: authAction.setAlertMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserActivation);
